import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import { action, computed, observable } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import EventBus, { totalCountBankTransfers, totalCountCardGateways } from "services/eventBus";
import PaymentCardGatewayViewModel from "./cardGateWay/paymentCardGatewayViewModel";
import PaymentBankTransferViewModel from "./bankTransfer/paymentBankTransferViewModel";

const navigationName = "payments";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [PaymentBankTransferViewModel, PaymentCardGatewayViewModel],
})
export default class PaymentsViewModel extends ConductorOneChildActive<
  PaymentBankTransferViewModel | PaymentCardGatewayViewModel
> {
  private unsubscribtions: Array<() => void> = [];
  @observable totalCountBankTransfers = 0;
  @observable totalCountCardGateways = 0;
  @observable itemsCount = 0;

  constructor(
    private bankTransferViewModel: PaymentBankTransferViewModel,
    private cardGatewayViewModel: PaymentCardGatewayViewModel,
    private localizationService: LocalizationService,
    private eventBus: EventBus
  ) {
    super();
    this.navigationName = navigationName;
    this.children.push(this.bankTransferViewModel);
    this.children.push(this.cardGatewayViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.unsubscribtions.push(
      this.eventBus.subscribe(totalCountBankTransfers, this.onTotalCountBankTransfers),
      this.eventBus.subscribe(totalCountCardGateways, this.onTotalCountCardGateways)
    );
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  @computed
  get name() {
    return this.translate("name");
  }

  @computed
  get isDetailChildActivated() {
    return !!this.children[0].activeChild || !!this.children[1].activeChild;
  }

  @computed
  get detailChildActivated() {
    return this.children[0].activeChild ?? this.children[1].activeChild;
  }

  @action.bound
  private onTotalCountBankTransfers(event: ReturnType<typeof totalCountBankTransfers>) {
    this.totalCountBankTransfers = event.payload.totalCountBankTransfers ?? 0;
    this.getItemsCount();
  }

  @action.bound
  private onTotalCountCardGateways(event: ReturnType<typeof totalCountCardGateways>) {
    this.totalCountCardGateways = event.payload.totalCountCardGateways ?? 0;
    this.getItemsCount();
  }

  getItemsCount(): void {
    if (this.activeChild instanceof PaymentBankTransferViewModel) {
      this.itemsCount = this.activeChild.totalCountBankTransfers;
    } else if (this.activeChild instanceof PaymentCardGatewayViewModel) {
      this.itemsCount = this.activeChild.totalCountCardGateways;
    } else {
      this.itemsCount = 0;
    }
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `payments.${code}`, size);
  }
}
